import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import Typography from '@/common/components/base/typography/Typography';
import { FileStateOptionModalType } from '@/modules/FileList/components/listFilterSection/advanceFilter/components/FileStateModal/FileStateModal.type';
import { Box } from 'styled-system/jsx';

const FileStateModal = ({ options, onClick }: FileStateOptionModalType) => {
  return (
    <Box
      display="flex"
      gap="1rem"
      alignItems="stretch"
      flexDirection="column"
      flexWrap="wrap"
      my="3rem"
      justifyContent="space-between"
    >
      {options.map((item, index) => {
        return (
          <>
            <Box
              cursor={item.count === 0 ? 'not-allowed' : 'pointer'}
              onClick={() => {
                item.count !== 0 && onClick(item);
              }}
              key={`${item.value}`}
            >
              <Box display="flex" justifyContent="space-between">
                <Typography
                  cursor="pointer"
                  textAlign="center"
                  minWidth="20px"
                  color="color.black"
                  textStyle="b1"
                >
                  {item.label}
                </Typography>
                <Box mb="5px">
                  <CustomLabel
                    title={`${item.count} مورد`}
                    color={item.count === 0 ? 'black' : 'purpleLight'}
                  />
                </Box>
              </Box>
            </Box>
            {index !== options.length - 1 && (
              <Box
                display="flex"
                paddingX={'1rem'}
                alignItems="center"
                gap="5px"
              >
                <Box borderBottom="1px solid {colors.gray-1}" width="100%" />
              </Box>
            )}
          </>
        );
      })}
    </Box>
  );
};

export default FileStateModal;
